import '../Profile.css'
import { AppContext } from "contexts/AppContext";
import Wishlist from "../Wishlist";
import { useContext } from "react";

const WishlistPage = () => {
    const contextState = useContext(AppContext)
    const { accessibleShops } = contextState

    const defaultShopID = accessibleShops && accessibleShops.length > 0
        ? accessibleShops[0].ShopID
        : null;

    return (
        <Wishlist defaultShopID={defaultShopID} />
    )
}

export default WishlistPage